/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GcpNetworkInterface { 
    /**
     * IP Address
     */
    ip: string;
    /**
     * Name of the nic
     */
    name: string;
    /**
     * Public IP Address
     */
    public_ip?: string;
    /**
     * Subnet
     */
    subnet: string;
    /**
     * VPC
     */
    'vpc-network': string;
}

